import React from 'react';
import classnames from 'classnames';
import { CheckboxProps, Checkbox } from 'tea-component';
import TimeChangeLegend, { ITimeChangeLegendProps } from '@gp/components/TimeChangeLegend';
import type { IBaseProps } from '@home/types/common';
import './index.scss';

interface ITimeChangeCheckboxProps
  extends IBaseProps,
    Omit<CheckboxProps, 'children'>,
    ITimeChangeLegendProps {
  name?: string;
  value: boolean;
  onChange?: (payload: boolean) => void;
}

const TimeChangeCheckbox: React.FC<ITimeChangeCheckboxProps> = (props) => {
  const {
    style,
    className,
    disabled,
    name = <span className="dbg-time-change-checkbox-name">Time Change</span>,
    tips = 'Milestone updated in the past 30 days',
    bubbleProps,
    value,
    onChange,
  } = props;

  const handleTimeChange = () => {
    if (!disabled) {
      onChange?.(!value);
    }
  };

  return (
    <div
      style={style}
      className={classnames('dbg-time-change-checkbox', className, {
        'dbg-time-change-checkbox-disabled': disabled,
      })}
      // onClick={handleTimeChange}
    >
      {/* <i
        className="dbg-schedule-calendar-legend-icon"
        style={{ backgroundColor: value ? '#EDA53A' : '#EBECF1' }}
      ></i> */}
      <Checkbox disabled={disabled} value={value} onChange={handleTimeChange} />
      <TimeChangeLegend name={name} tips={tips} bubbleProps={bubbleProps} />
    </div>
  );
};

export default TimeChangeCheckbox;
